var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"viewBox":"0 0 22 16","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M19.784 3.846l-8.686 5-8.685-5v-2l8.685 5 8.686-5v2zM19.543 0H2.17C.966 0 0 .89 0 2v12c0 1.105.972 2 2.171 2h17.372c1.2 0 2.171-.895 2.171-2V2c0-1.11-.977-2-2.171-2z","fill":"#FFF"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }